<template>

<core-modal-setting :title="(isPlaceholder) ? 'Restrict Filters' : 'Filters'" :value="valueText" :placeholder="(isPlaceholder) ? 'All filters' : 'Always shown'">
        
    <core-input-multiselect :options="options" v-model="internalValue" placeholder="Search filters..." />

</core-modal-setting>

</template>

<script>

import mixSetting from 'core/mixin/modal/Setting'
import $filter from '@/filter'

export default {

    mixins: [mixSetting],

    props: ['field'],

    data: function() {

        return {
            noun: 'filter'
        }

    },

    computed: {

        isPlaceholder: function() {

            return this.field.key === 'dynamic.placeholder'

        },

        options: function() {

            var options = []

            this.$_.each($filter.types, function(type) {

                options.push({
                    value: type.key,
                    text: type.lang.name
                })

            })

            return options

        }

    }

}

</script>

<style scoped>

</style>